<template>
  <svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" version="1.1" style="shape-rendering:geometricPrecision; text-rendering:geometricPrecision; image-rendering:optimizeQuality; fill-rule:evenodd; clip-rule:evenodd"
viewBox="0 0 5048 4984"
 xmlns:xlink="http://www.w3.org/1999/xlink">
 <g id="Vrstva_x0020_1">
  <g id="_667460736">
   <path class="fil0" d="M4702 0l-4287 0c-416,0 -346,645 -346,645l4978 0c0,0 30,-645 -345,-645z"/>
   <polygon class="fil0" points="59,4984 5042,4984 5042,4339 59,4339 "/>
   <path class="fil0" d="M293 3851l0 -2814c0,-81 -65,-147 -146,-147 -81,0 -147,66 -147,147l0 2814c0,81 66,147 147,147 81,0 146,-66 146,-147z"/>
   <path class="fil0" d="M5042 3851l0 -2814c0,-81 -65,-147 -146,-147 -81,0 -147,66 -147,147l0 2814c0,81 66,147 147,147 81,0 146,-66 146,-147z"/>
  </g>
 </g>
</svg>
</template>

<script>
export default {
  name: 'JalousieUp',
};
</script>

<style scoped>
.fil0 {fill:#1DAAE1;fill-rule:nonzero}
</style>
